import { LoginPage } from './login';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FlxCommonsModule } from "@questrade/flx-commons";

@NgModule({
    declarations: [
        LoginPage,
    ],
    imports: [
        FlxCommonsModule,
        IonicPageModule.forChild(LoginPage),
    ],
    exports: [
        LoginPage
    ]
})
export class LoginPageModule { }



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts